module.exports = __webpack_public_path__ + "img/floorPlanEvent.e309f920.svg";